import React from 'react';
import classes from "./MatchRewardsPage2.module.css";
import { FaArrowLeft, FaTrophy, FaCheck } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';


const RANK_MEDAL = { 1: "🥇", 2: "🥈", 3: "🥉" };

const MatchRewardsPage2 = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    /* ── Rank-based prize config — update values to match your actual Vodacom tiers ── */
    const RANK_PRIZES = {
        1: { label: "1st Place", prizes: [{ icon: "📱", type: "Smartphone", value: t("248") }] },
        2: { label: "2nd Place", prizes: [{ icon: "👕", type: "Jersey", value: t("249") }] },
        3: { label: "3rd Place", prizes: [{ icon: "💰", type: "Airtime", value: t("250") }] },
    };

    return (
        <div className={classes.page}>

            {/* ── background effects ── */}
            <div className={classes.bgGlow} />

            {/* ══ HEADER ══ */}
            <div className={classes.header}>
                <button className={classes.backBtn} onClick={() => navigate(-1)}>
                    <FaArrowLeft />
                </button>
                <span className={classes.headerTitle}>{t("246")}</span>
                <div style={{ width: 38 }} />
            </div>

            {/* ══ CONTENT ══ */}
            <div className={classes.content}>

                {/* ── All prizes reference table ── */}
                <div className={classes.allPrizesCard}>
                    <p className={classes.allPrizesTitle}>{t("247")}</p>
                    <div className={classes.allPrizesRows}>
                        {Object.entries(RANK_PRIZES).map(([r, data]) => {
                            // const isCurrentRank = Number(r) === user_rank;
                            return (
                                <div key={r} className={`${classes.tierRow}`}>
                                    <span className={classes.tierRank}>
                                        {RANK_MEDAL[r] ?? `#${r}`}
                                    </span>
                                    <span className={classes.tierLabel}>{data.label}</span>
                                    <div className={classes.tierPrizes}>
                                        {data.prizes.map((p, i) => (
                                            <span key={i} className={classes.tierPrizeChip}>
                                                {p.icon} {p.value}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default MatchRewardsPage2;